import React, { Component } from "react";
import { remoteLog } from "../../../../common/logging";
import { PageFooter } from "../../../page_footer";
import { PageHeader } from "../../../page_header";
import { PatientMenu } from "../../../patient_menu";
import PaymentInvoiceError from "./payment_invoice_error";

class PaymentInvoiceErrorBody extends Component {
  componentDidCatch(e) {
    remoteLog(e, "payment_invoice_error_body");
  }

  render() {
    // See the success body: chromeless branch for the redesign shell.
    if (this.props.bareLayout) {
      return <PaymentInvoiceError {...this.props} />;
    }

    return (
      <div>
        <PageHeader {...this.props} />
        <div className="container">
          <div className="page-container">
            <PatientMenu {...this.props} />
            <PaymentInvoiceError {...this.props} />
          </div>
          <PageFooter {...this.props} />
        </div>
      </div>
    );
  }
}

export default PaymentInvoiceErrorBody;
